var validProps = ['veltIf', 'veltClass', 'className', 'variant'];
export var transformWireframeProps = function (props) {
    try {
        var transformedProps_1 = {};
        Object.entries(props).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (key === 'children' || key === 'ref' || !validProps.includes(key)) {
                transformedProps_1[key] = value;
                return;
            }
            if (key === 'className') {
                transformedProps_1['class'] = value;
                return;
            }
            // Convert camelCase to dash-case
            var dashKey = key.replace(/[A-Z]/g, function (letter) { return "-".concat(letter.toLowerCase()); });
            transformedProps_1[dashKey] = value;
            // // Handle boolean values - only convert if explicitly true/false
            // if (typeof value === 'boolean') {
            //     transformedProps[dashKey] = [true, false].includes(value) ? (value ? 'true' : 'false') : undefined;
            // } else {
            //     transformedProps[dashKey] = value;
            // }
        });
        return transformedProps_1;
    }
    catch (error) {
        return props;
    }
};
/**
 * To deep compare two objects.
 * @param arg1 object 1
 * @param arg2 object 2
 * @returns true if both objects are equal, false otherwise
 */
export var deepCompare = function (arg1, arg2) {
    try {
        if (Object.prototype.toString.call(arg1) === Object.prototype.toString.call(arg2)) {
            if (Object.prototype.toString.call(arg1) === '[object Object]' || Object.prototype.toString.call(arg1) === '[object Array]') {
                if (Object.keys(arg1).length !== Object.keys(arg2).length) {
                    return false;
                }
                return (Object.keys(arg1).every(function (key) {
                    return deepCompare(arg1[key], arg2[key]);
                }));
            }
            return (arg1 === arg2);
        }
        return false;
    }
    catch (err) {
        return false;
    }
};
